
namespace RioERP.Reports {
    export class OrderShippingReportColumns {
        static columnsKey = 'Reports.OrderShippingReport';
    }
}